export const allData = [
    {
        id: 1,
        img: "../images/sodcutter.JPG",
        name: "Sod Cutter",
        link: '/catalog/sodcutter',
    },
    {
        id: 2,
        img: "../images/logsplitter.JPG",
        name: "Log Splitter",
        link: '/catalog/logsplitter',
    },
    {
        id: 3,
        img: "../images/thatcher.JPG",
        name: "Thatcher",
        link: '/catalog/thatcher',
    },
    {
        id: 4,
        img: "../images/areator.JPG",
        name: "Areator",
        link: '/catalog/areator',
    },
    {
        id: 5,
        img: "../images/edger.JPG",
        name: "Edger",
        link: '/catalog/edger',
    },
    {
        id: 6,
        img: "../images/lawnroller.JPG",
        name: "Lawn Roller",
        link: '/catalog/lawnroller',
    },
    {
        id: 7,
        img: "../images/walkblower.JPG",
        name: "Walk Behind Blower",
        link: '/catalog/walkbehindblower',
    },
    {
        id: 8,
        img: "../images/backpackblower.webp",
        name: "Backpack Blower",
        link: '/catalog/backpackblower',
    },
    {
        id: 9,
        img: "../images/wheelloader.JPG",
        name: "Wheel Loader",
        link: '/catalog/wheelloader',
    },
    {
        id: 10,
        img: "../images/trackloader.jpeg",
        name: "Track Loader",
        link: '/catalog/trackloader',
    },
    {
        id: 11,
        img: "../images/miniex.JPG",
        name: "Mini Excavataur",
        link: '/catalog/miniexcavataur',
    },
    {
        id: 12,
        img: "../images/miniskid.JPG",
        name: "Mini Skid-Steer",
        link: '/catalog/miniskidsteer',
    },
    {
        id: 13,
        img: "../images/buggy.JPG",
        name: "Concrete Buggy",
        link: '/catalog/concretebuggy',
    },
    {
        id: 14,
        img: "../images/compactor.JPG",
        name: "Compactor",
        link: '/catalog/compactor',
    },
    {
        id: 15,
        img: "../images/jackhammer.JPG",
        name: "Jack Hammer",
        link: '/catalog/jackhammer',
    },
    {
        id: 16,
        img: "../images/cementmixer.JPG",
        name: "Cement Mixer",
        link: '/catalog/cementmixer',
    },
    {
        id: 17,
        img: "../images/hammerdrill.JPG",
        name: "Hammer Drill",
        link: '/catalog/hammerdrill',
    },
    {
        id: 18,
        img: "../images/bullfloat.JPG",
        name: "Bull Float",
        link: '/catalog/bullfloat',
    },
    {
        id: 19,
        img: "../images/cutoffsaw.JPG",
        name: "Handheld Cutoff Saw",
        link: '/catalog/cutoffsaw',
    },
    {
        id: 20,
        img: "../images/tilesaw.JPG",
        name: "Tile Saw",
        link: '/catalog/tilesaw',
    },
    {
        id: 21,
        img: "../images/walksaw.JPG",
        name: "Walk Behind Saw",
        link: '/catalog/walkbehindsaw',
    },
    {
        id: 22,
        img: "../images/sawzall.JPG",
        name: "Sawzall",
        link: '/catalog/sawzall',
    },
    {
        id: 23,
        img: "../images/sawblades.JPG",
        name: "Saw Blades",
        link: '/catalog/sawblades',
    },
    {
        id: 24,
        img: "../images/twoman.JPG",
        name: "2-Man Hydraulic Auger",
        link: '/catalog/hydraulicauger',
    },
    {
        id: 25,
        img: "../images/augerbits.JPG",
        name: "Auger Bits",
        link: '/catalog/augerbits',
    },
    {
        id: 26,
        img: "../images/aframe.JPG",
        name: "A Frame Ladders",
        link: '/catalog/aframeladder',
    },
    {
        id: 27,
        img: "../images/extensionladder.JPG",
        name: "Extension Ladders",
        link: '/catalog/extensionladder',
    },
    {
        id: 28,
        img: "../images/indoorscaffolding.webp",
        name: "Indoor Scaffolding",
        link: '/catalog/indoorscaffolding',
    },
    {
        id: 29,
        img: "../images/outdoorscaffolding.jpeg",
        name: "Outdoor Scaffolding",
        link: '/catalog/outdoorscaffolding',
    },
    {
        id: 30,
        img: "../images/threeinch.JPG",
        name: "Three Inch Gas Pump",
        link: '/catalog/threeinchgaspump',
    },
    {
        id: 31,
        img: "../images/twoinch.JPG",
        name: "Two Inch Gas Pump",
        link: '/catalog/twoinchgaspump',
    },
    {
        id: 32,
        img: "../images/electric.JPG",
        name: "Two Inch Submersible Electric Pump",
        link: '/catalog/twoinchelectricpump',
    },
    {
        id: 33,
        img: "../images/washer.JPG",
        name: "Pressure Washer",
        link: '/catalog/pressurewasher',
    },
    {
        id: 34,
        img: "../images/threeinchhose.JPG",
        name: "Three Inch Discharge Hose",
        link: '/catalog/threeinchhose',
    },
    {
        id: 35,
        img: "../images/twoinchhose.JPG",
        name: "Two Inch Discharge Hose",
        link: '/catalog/twoinchhose',
    },
    {
        id: 36,
        img: "../images/largegenerator.JPG",
        name: "Large Generators",
        link: '/catalog/largegenerators',
    },
    {
        id: 37,
        img: "../images/smallgenerator.JPG",
        name: "Small Generators",
        link: '/catalog/smallgenerators',
    },
    {
        id: 38,
        img: "../images/twocompressor.JPG",
        name: "Tow Behind Compressor",
        link: '/catalog/towbehindcompressor',
    },
    {
        id: 39,
        img: "../images/mediumcompressor.JPG",
        name: "Medium Compressors",
        link: '/catalog/mediumcompressors',
    },
    {
        id: 40,
        img: "../images/smallcompressor.JPG",
        name: "Small Compressors",
        link: '/catalog/smallcompressors',
    },
    {
        id: 41,
        img: "../images/drumfan.JPG",
        name: "Drum Fan",
        link: '/catalog/drumfan',
    },
    {
        id: 41,
        img: "../images/exhaustfan.JPG",
        name: "Exhaust Fan",
        link: '/catalog/exhaustfan',
    },
    {
        id: 43,
        img: "../images/carpetcleaner.JPG",
        name: "Carpet Cleaner",
        link: '/catalog/carpetcleaner',
    },
    {
        id: 44,
        img: "../images/dehumidifier.JPG",
        name: "Dehumidifier",
        link: '/catalog/dehumidifier',
    },
    {
        id: 45,
        img: "../images/polisher.JPG",
        name: "Floor Polisher",
        link: '/catalog/floorpolisher',
    },
    {
        id: 46,
        img: "../images/wallpapersteamer.JPG",
        name: "Wallpaper Steamer",
        link: '/catalog/wallpapersteamer',
    },
    {
        id: 47,
        img: "../images/kneekicker.JPG",
        name: "Knee Kicker",
        link: '/catalog/kneekicker',
    },
    {
        id: 48,
        img: "../images/carpetfan.JPG",
        name: "Carpet Dryer Fan",
        link: '/catalog/carpetfan',
    },
    {
        id: 49,
        img: "../images/chair.webp",
        name: "Black Plastic Folding Chairs",
        link: '/catalog/foldingchairs',
    },
    {
        id: 50,
        img: "../images/8foottable.webp",
        name: "8 Foot Banquet Tables",
        link: '/catalog/8foottables',
    },
    {
        id: 51,
        img: "../images/6foottable.webp",
        name: "6 Foot Banquet Tables",
        link: '/catalog/6foottables',
    },
    {
        id: 52,
        img: "../images/5footround.webp",
        name: "5 Foot Round Tables",
        link: '/catalog/5foottables',
    },
    {
        id: 53,
        img: "../images/pontoon.JPG",
        name: "Pontoon Trailer",
        link: '/catalog/pontoontrailer',
    },
    {
        id: 54,
        img: "../images/blacktrl.JPG",
        name: "5x8 Enclosed Trailer",
        link: '/catalog/5x8enclosedtrailer',
    },
    {
        id: 55,
        img: "../images/bluetrl.JPG",
        name: "6x12 Enclosed Trailer",
        link: '/catalog/6x12enclosedtrailer',
    },
    {
        id: 56,
        img: "../images/hitch.JPG",
        name: "2 Inch Ball & Hitch",
        link: '/catalog/hitch',
    },
    {
        id: 57,
        img: "../images/adapter.JPG",
        name: "Trailer Light Adapter",
        link: '/catalog/lightadapter',
    },
    {
        id: 58,
        img: "../images/extralargebox.jpeg",
        name: "Extra Large Box",
        link: '/catalog/extralargebox',
    },
    {
        id: 59,
        img: "../images/largebox.jpeg",
        name: "Large Box",
        link: '/catalog/largebox',
    },
    {
        id: 60,
        img: "../images/mediumbox.jpeg",
        name: "Medium Box",
        link: '/catalog/mediumbox',
    },
    {
        id: 61,
        img: "../images/smallbox.jpeg",
        name: "Small Box",
        link: '/catalog/smallbox',
    },
    {
        id: 62,
        img: "../images/grandwardrobe.jpeg",
        name: "Grand Wardrobe Box",
        link: '/catalog/grandwardrobebox',
    },
    {
        id: 63,
        img: "../images/shortwardrobe.jpeg",
        name: "Shorty Wardrobe Box",
        link: '/catalog/shortywardrobebox',
    },
    {
        id: 64,
        img: "../images/bubblewrap.jpeg",
        name: "Bubble Wrap",
        link: '/catalog/bubblewrap',
    },
    {
        id: 65,
        img: "../images/wrappingpaper.jpeg",
        name: "Wrapping Paper",
        link: '/catalog/wrappingpaper',
    },
    {
        id: 66,
        img: "../images/dolly.webp",
        name: "Appliance Dolly",
        link: '/catalog/appliancedolly',
    },
    {
        id: 67,
        img: "../images/drywalljack.webp",
        name: "Drywall Jack",
        link: '/catalog/drywalljack',
    },
    {
        id: 68,
        img: "../images/extensioncord.JPG",
        name: "Extension Cord",
        link: '/catalog/extensioncord',
    },
    {
        id: 69,
        img: "../images/albrake.webp",
        name: "Aluminum Brake",
        link: '/catalog/alumunimbrake',
    },
    {
        id: 70,
        img: "../images/metaldetector.JPG",
        name: "Metal Detector",
        link: '/catalog/metaldetector',
    },
    {
        id: 71,
        img: "../images/nailer.webp",
        name: "Nailer",
        link: '/catalog/nailer',
    },
]